enum UploadedFileType {
  EMAIL_ATTACHMENT = 'EMAIL_ATTACHMENT',
}

export default UploadedFileType;
